const getInitials = (fullName) => {
    const names = fullName.split(' ');
    const firstNameInitial = names[0].charAt(0).toUpperCase();
    const lastNameInitial = names[names.length - 1].charAt(0).toUpperCase();
    return `${firstNameInitial}${lastNameInitial}`;
}

export default getInitials